import { DataTypeProvider } from "@devexpress/dx-react-grid"
import React from "react"
import TimeAgo from 'react-timeago'

const DateFormatter = ({ value }) => {
  value = (!value) ? '0000-00-00 00:00:00' : value.trim()
  if (value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />
